<template>
    <div class="service-content">
        <div class="service">
            <div class="l-con">
                <div class="l-item">
                    <div class="item">
                        <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logos/icon_03%402x.png" class="img" />
                        <div class="item-title">以深入的产品调研为基础，结合专业严谨的结构、传动设计，形成完善的产品方案。</div>
                    </div>
                    <div class="item mg-24">
                        <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logos/icon_02%402x.png" class="img" />
                        <div class="item-title">团队具有丰富的移动端程序开发经验，为产品功能的实现提供强有力的技术支撑。</div>
                    </div>
                </div>
                <div class="l-item mg-l-24">
                    <div class="item">
                        <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/logos/icon_01%402x.png" class="img" />
                        <div class="item-title">通过不断改进和持续迭代，可以确保软件产品始终处于良好的状态并满足用户需求。</div>
                    </div>
                </div>
            </div>
            <div class="r-con">
                <div class="title">哪些场景<br/>
                需要我们的服务</div>
                <div class="info">根据客户的需求和市场趋势，不同类型的组织可能需要定制化的解决方案来满足其特定的业务目标和需求。</div>
                <div class="contact">联系我们</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style scoped lang="scss">
    .service-content{
        width: 100%;
        background: #FCFBFF;
        height: 800px;
        display: flex;
        align-items: center;
        .service{
            width: 1200px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            width: 1200px;
            margin: 0 auto 0;
            .l-con{
                display: flex;
                align-items: center;
                .l-item{
                    display: flex;
                    flex-direction:column;
                    align-items: center;
                    .item{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        max-width: 306px;
                        padding: 40px 30px;
                        box-sizing: border-box;
                        background: #FFFFFF;
                        box-shadow: 0px 4px 40px 0px rgba(43,89,255,0.08);
                        border-radius: 10px;
                        .img{
                            width: 60px;
                            height: 60px;
                        }
                        .item-title{
                            font-size: 16px;
                            font-family: PingFangSC-Regular, PingFang SC;
                            font-weight: 400;
                            color: #000B33;
                            line-height: 26px;
                            text-align: center;
                            margin-top: 10px;
                        }
                    }
                    .mg-24{
                        margin-top: 24px;
                    }
                    
                }
                .mg-l-24{
                    margin-left: 24px;
                }
            }
            .r-con{
                margin-left: 134px;
                .title{
                    font-size: 36px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #000B33;
                    line-height: 54px;
                }
                .info{
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #000B33;
                    line-height: 26px;
                    margin-top: 38px;
                }
                .contact{
                    width: 150px;
                    height: 50px;
                    background: #44D7B6;
                    border-radius: 25px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 24px;
                    margin-top: 38px;
                }
            }
        }
    }
</style>